<div class="dialog-header">
  <div class="dialog-header-title">{{ 'lobby.dialog.legends.title' | translate }}</div>
  <div class="dialog-header-close-button">
    <button (click)="close()">
      <svg-icon
        src="assets/img/icons/dialog-close.svg"
        [stretch]="true"
        [applyClass]="true"
        class="dialog-header-close-button-icon"
      />
    </button>
  </div>
</div>
<div class="dialog-content">
  <div
    class="app-lobby-dialog-legends-item"
    *ngFor="let legendItem of dialogData.gameLegend"
  >
    <span class="app-lobby-dialog-legends-item-icon">
      <img src="assets/img/icons/legend/{{ legendItem.image }}.svg" />
    </span>
    <span class="app-lobby-dialog-legends-item-label">
      {{ legendItem.label | translate }}
    </span>
  </div>

  <button
    appButton
    class="app-lobby-dialog-legends-btn-more"
    (click)="showOtherLegendInfo = !showOtherLegendInfo"
  >
    {{ 'lobby.dialog.legends.more' | translate }}
    <i
      class="bi"
      [ngClass]="{
        ' bi-chevron-down': !showOtherLegendInfo,
        ' bi-chevron-up': showOtherLegendInfo
      }"
    ></i>
  </button>

  <ng-container *ngIf="showOtherLegendInfo">
    <div
      class="app-lobby-dialog-legends-item"
      *ngFor="let legendItem of dialogData.otherLegend"
    >
      <span class="app-lobby-dialog-legends-item-icon">
        <img src="assets/img/icons/legend/{{ legendItem.image }}.svg" />
      </span>
      <span class="app-lobby-dialog-legends-item-label">
        {{ legendItem.label | translate }}
      </span>
    </div>
  </ng-container>
</div>
<div class="dialog-footer">
  <button appButton (click)="close()">{{ 'component.dialog.button.close' | translate }}</button>
</div>
